/* eslint-disable no-unused-vars */
import {
  AttachMoney,
  BarChartRounded,
  DirectionsBoatRounded,
  HomeWorkRounded,
  MonetizationOnRounded,
  OutputRounded,
  Storefront,
  StorefrontRounded,
  TroubleshootRounded
} from '@mui/icons-material';

import { URL_ENDPOINT } from 'src/utils/constants/service';

export enum TypeTabTradeData {
  TradeData = 'Bills of Lading',
  MarketAnalytics = 'Market Analytics',
  MarketForecasts = 'Market Forecasts',
  RouteMarket = 'Route to Market',
  SupplierCountry = 'Supplier Country',
  BuyerCountry = 'Buyer Country',
  PortOrigin = 'Port of Origin',
  PortDelivery = 'Port of Delivery',
  Suppliers = 'Suppliers',
  Buyers = 'Buyers',
  UnitPriceSuppliers = 'Unit Price Suppliers',
  UnitPriceBuyers = 'Unit Price Buyers',
  AverageUnitPrice = 'Average Unit Price',
}

export const TABS_TRADE_DATA: ITabSetting[] = [
  {
    key: TypeTabTradeData.BuyerCountry,
    label: TypeTabTradeData.BuyerCountry,
    icon: OutputRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.buyerCountryWorldMap,
      URL_ENDPOINT.tradeData.buyerCountryAIExplanation,
      URL_ENDPOINT.tradeData.buyerCountryTable,
      URL_ENDPOINT.tradeData.buyerCountryCompany,
    ],
  },
  {
    key: TypeTabTradeData.SupplierCountry,
    label: TypeTabTradeData.SupplierCountry,
    icon: OutputRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.supplierCountryWorldMap,
      URL_ENDPOINT.tradeData.supplierCountryAIExplanation,
      URL_ENDPOINT.tradeData.supplierCountryTable,
      URL_ENDPOINT.tradeData.supplierCountryCompany,
    ],
  },
  {
    key: TypeTabTradeData.Buyers,
    label: TypeTabTradeData.Buyers,
    icon: MonetizationOnRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.buyersChart,
      URL_ENDPOINT.tradeData.buyersTable,
      URL_ENDPOINT.tradeData.buyersListSuppliers,
    ],
  },
  {
    key: TypeTabTradeData.UnitPriceBuyers,
    label: TypeTabTradeData.UnitPriceBuyers,
    icon: AttachMoney,
    disable: false,
    endpoints: [URL_ENDPOINT.tradeData.unitPriceBuyersChart, URL_ENDPOINT.tradeData.unitPriceBuyersTable],
  },
  {
    key: TypeTabTradeData.Suppliers,
    label: TypeTabTradeData.Suppliers,
    icon: StorefrontRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.suppliersChart,
      URL_ENDPOINT.tradeData.suppliersTable,
      URL_ENDPOINT.tradeData.suppliersListBuyers,
    ],
  },
  {
    key: TypeTabTradeData.UnitPriceSuppliers,
    label: TypeTabTradeData.UnitPriceSuppliers,
    icon: Storefront,
    disable: false,
    endpoints: [URL_ENDPOINT.tradeData.unitPriceSuppliersChart, URL_ENDPOINT.tradeData.unitPriceSuppliersTable],
  },
  {
    key: TypeTabTradeData.AverageUnitPrice,
    label: TypeTabTradeData.AverageUnitPrice,
    icon: Storefront,
    disable: false,
    endpoints: [URL_ENDPOINT.tradeData.averageUnitPriceChart, URL_ENDPOINT.tradeData.averageUnitPriceTable],
  },
  {
    key: TypeTabTradeData.MarketAnalytics,
    label: TypeTabTradeData.MarketAnalytics,
    icon: BarChartRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.marketAnalyticsChart,
      URL_ENDPOINT.tradeData.marketAnalyticsAIExplanation,
      URL_ENDPOINT.tradeData.marketAnalyticsTable,
      URL_ENDPOINT.tradeData.marketAnalyticBuyers,
      URL_ENDPOINT.tradeData.marketAnalyticSuppliers,
      URL_ENDPOINT.tradeData.marketAnalyticsWorldMap,
    ],
  },
  {
    key: TypeTabTradeData.PortDelivery,
    label: TypeTabTradeData.PortDelivery,
    icon: DirectionsBoatRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.portDeliveryChart,
      URL_ENDPOINT.tradeData.portDeliverTable,
      URL_ENDPOINT.tradeData.portDeliveryBuyerList,
      URL_ENDPOINT.tradeData.portDeliverySupplierList,
    ],
  },
  {
    key: TypeTabTradeData.PortOrigin,
    label: TypeTabTradeData.PortOrigin,
    icon: HomeWorkRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.portOriginChart,
      URL_ENDPOINT.tradeData.portOriginTable,
      URL_ENDPOINT.tradeData.portOriginBuyerList,
      URL_ENDPOINT.tradeData.portOriginSupplierList,
    ],
  },
  {
    key: TypeTabTradeData.TradeData,
    label: TypeTabTradeData.TradeData,
    icon: TroubleshootRounded,
    disable: false,
    endpoints: [
      URL_ENDPOINT.tradeData.transactions,
      URL_ENDPOINT.tradeData.transactionsCount,
      URL_ENDPOINT.tradeData.transactionsPaymentStatus,
    ],
  },
];

export enum TypeTabTradeSearchForms {
  GlobalTradeData = 'HS code',
  CompanyTradeData = 'Company',
}

export const TABS_TRADE_SEARCH_FORMS: ITabSetting[] = [
  {
    key: TypeTabTradeSearchForms.GlobalTradeData,
    label: TypeTabTradeSearchForms.GlobalTradeData,
    icon: undefined,
    disable: false,
  },
  {
    key: TypeTabTradeSearchForms.CompanyTradeData,
    label: TypeTabTradeSearchForms.CompanyTradeData,
    icon: undefined,
    disable: false,
  },
];

export const ID_COMPONENT_TRADE = 'adamftd-trade-data-component-print';
